import { Languages } from "lucide-react";
import { useLocale } from "@/i18n/LocaleProvider";
import { Button } from "@/components/ui/button";

interface Props {
  variant?: "ghost" | "outline";
  size?: "sm" | "default" | "icon";
  className?: string;
}

export default function LanguageSwitcher({ variant = "ghost", size = "sm", className }: Props) {
  const { locale, setLocale } = useLocale();
  const next = locale === "ro" ? "en" : "ro";
  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => setLocale(next)}
      aria-label={locale === "ro" ? "Switch to English" : "Comută la română"}
      className={className}
    >
      <Languages className="h-4 w-4" />
      <span className="ml-1 text-xs font-semibold uppercase">{next}</span>
    </Button>
  );
}
